<template>
  <div class="store">
    <!-- 无数据 -->
    <div class="ws-box column aCenter" v-show="msg">
      <img class="ws-img" src="../../assets/img/img_wanshan.png" alt="" />
      <div class="ws-btn" @click="complateMsg">完善您的企业信息</div>
    </div>
    <!--有数据 -->
    <div class="big-box" v-show="!msg">
      <div class="czjl">完善您的企业信息</div>
      <div class="content">
        <div class="flex aCenter jAround">
          <div class="left">
            <img src="../../assets/img/icon_hangye.png" alt="" />
            <span class="text">你的行业</span>
          </div>
          <div class="flex flex-1">
            <el-radio-group v-model="radio" @change="radiochange">
              <el-radio class="radio" label="电商" border>
                <div class="column aCenter jBetween">
                  <img
                    v-if="activeradio1"
                    src="../../assets/img/icon_dianshang_selected.png"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../assets/img/icon_dianshang_normal.png"
                    alt=""
                  />
                  <div class="bot-text">电商</div>
                </div>
              </el-radio>
              <el-radio class="radio" label="APP" border>
                <div class="column aCenter jBetween">
                  <img
                    v-if="activeradio2"
                    src="../../assets/img/icon_app_selected.png"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../assets/img/icon_app_normal.png"
                    alt=""
                  />
                  <div class="bot-text">APP</div>
                </div>
              </el-radio>
              <el-radio class="radio" label="游戏" border>
                <div class="column aCenter jBetween">
                  <img
                    v-if="activeradio3"
                    src="../../assets/img/icon_youxi_selected.png"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../assets/img/icon_youxi_normal.png"
                    alt=""
                  />
                  <div class="bot-text">游戏</div>
                </div>
              </el-radio>
              <el-radio class="radio" label="品牌其他" border>
                <div class="column aCenter jBetween">
                  <img
                    v-if="activeradio4"
                    src="../../assets/img/icon_qita_selected.png"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../assets/img/icon_qita_normal.png"
                    alt=""
                  />
                  <div class="bot-text">品牌其他</div>
                </div>
              </el-radio>
            </el-radio-group>
          </div>
        </div>

        <div class="flex aCenter jAround mar-top">
          <div class="left">
            <img src="../../assets/img/icon_yezz.png" alt="" />
            <span class="text">你的营业执照</span>
          </div>
          <div class="flex-1">
            <el-upload
              ref="upload"
              class="upload-demo"
              drag
              :show-file-list="false"
              :limit="1"
              :on-exceed="onExceed"
              action="http://ycheng.1122334455.cn/api/login/uploadImg"
              :on-success="handleAvatarSuccess"
              multiple
            >
              <div v-if="img == ''">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  点击上传正确的营业执照， 否则审核可能不会通过
                </div>
              </div>
              <div v-else>
                <img class="iimg" :src="img" alt="" />
              </div>
            </el-upload>
          </div>
        </div>

        <div class="sbsb flex aCenter jCenter">
          <!-- <img src="../../assets/img/icon_true.png" alt="" />
          <div>识别失败，请填写如下信息</div> -->
        </div>

        <div class="flex aCenter jAround mar-top">
          <div class="left">
            <img src="../../assets/img/icon_qyxx.png" alt="" />
            <span class="text">你的企业信息</span>
          </div>
          <div class="flex-1" style="display: none">
            <div class="linethree">
              营业执照成功上传后，将在此处显示相应的企业信息，如有不符，可手动调整
            </div>
          </div>

          <div class="flex-1">
            <div class="flex aCenter matop">
              <div class="inputext">公司名称</div>
              <el-input placeholder="请输入中文公司名称" v-model="group_name">
              </el-input>
            </div>
            <div class="flex aCenter matop">
              <div class="inputext">公司英文名称</div>
              <el-input placeholder="请输入英文公司名称" v-model="en_name">
              </el-input>
            </div>

            <div class="flex aCenter matop">
              <div class="inputext">统一社会 信用代码</div>
              <el-input
                placeholder="请输入统一社会信用代码"
                @blur="inputChange"
                v-model="group_code"
              >
              </el-input>
            </div>
            <div class="flex aCenter matop">
              <div class="inputext">公司注册 地址</div>
              <el-input placeholder="请输入中文公司注册地址" v-model="address">
              </el-input>
            </div>

            <div class="flex aCenter matop">
              <div class="inputext">公司英文注册地址</div>
              <el-input
                placeholder="请输入英文公司注册地址"
                v-model="en_address"
              >
              </el-input>
            </div>

            <div class="flex aCenter matop">
              <div class="inputext">法人代表</div>
              <el-input placeholder="请输入法人代表" v-model="username">
              </el-input>
            </div>
            <div class="btn" @click="final">完成</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Index from "./Index";
import { getQyApi } from "../../network/api";
export default {
  name: "Store",
  mixins: [Index],
  created() {
    let token = this.$store.state.userinfo.token;
    getQyApi(token)
      .then((res) => {
        console.log(res);
        this.type = res.data.data.type || "";
        this.radio = res.data.data.type || "";
        this.img = res.data.data.img || "";
        this.uimg = res.data.data.img || "";
        this.group_name = res.data.data.group_name || "";
        this.en_name = res.data.data.en_name || "";
        this.group_code = res.data.data.group_code || "";
        this.address = res.data.data.address || "";
        this.en_address = res.data.data.en_address || "";
        this.username = res.data.data.username || "";
        if (this.radio == "电商") {
          this.activeradio1 = true;
        } else if (this.radio == "APP") {
          this.activeradio2 = true;
        } else if (this.radio == "游戏") {
          this.activeradio3 = true;
        } else if (this.radio == "品牌其他") {
          this.activeradio4 = true;
        }
        if (
          this.type == "" ||
          this.radio == "" ||
          this.img == "" ||
          this.group_name == "" ||
          this.en_name == "" ||
          this.group_code == "" ||
          this.address == "" ||
          this.en_address == "" ||
          this.username == ""
        ) {
          this.msg = true;
        } else {
          this.msg = false;
        }
      })
      .catch();
  },
};
</script>
<style scoped src="./Store.css"></style>
